import { useMemo } from 'react';

import { MultipleSelection } from '../../../../../components';
import { useTranslation } from '../../../../../hooks';
import useAssets from '../../../../../hooks/useAssets';
import { translatePrefix } from '../..';
import useMerchantList from '../../../../../hooks/useMerchantList';

interface IProps {
  label?: string;
  value: string[];
  onChange: (value: string[]) => void;
  onClear: () => void;
  disabled?: boolean;
}

const MerchantNameMultipleSelect = (props: IProps) => {
  const { label, value, onChange, onClear, disabled } = props;
  const { t } = useTranslation(translatePrefix);
  const { merchantList } = useMerchantList();

  const formatMerchantNameLabel = (enumKey: string) => {
    return enumKey;
  };

  // Create enum data from the merchant list
  const MerchantNameEnum = useMemo(() => {
    if (!merchantList) {
      return {};
    }

    const enumData: Record<string, string> = {};

    merchantList.forEach((merchant) => {
      enumData[merchant.name] = String(merchant.merchantId);
    });

    return enumData;
  }, [merchantList]);

  return (
    <MultipleSelection
      label={label || t('merchantName')}
      value={value}
      onChange={onChange}
      clearSelect={onClear}
      enumData={MerchantNameEnum}
      nameFn={formatMerchantNameLabel}
      disabled={disabled}
    />
  );
};

export default MerchantNameMultipleSelect;
